import { render } from "./DataPrice.vue?vue&type=template&id=8c27c9c4&ts=true"
import script from "./DataPrice.vue?vue&type=script&lang=tsx"
export * from "./DataPrice.vue?vue&type=script&lang=tsx"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__